import Vue from 'vue';
import axios from 'axios';

axios.defaults.withCredentials = true;

const auth = Vue.observable({
name:"",surname:"",menus:[],tip:"kullanici"
});

// const fetchSession = async () => {
//   try {
//     const res = await axios.get('/api/userinfo');
//     auth.isAuthenticated = true;
//     auth.username = res.data.username;
//     auth.roles = res.data.roles;
//     auth.permissions = res.data.permissions;
//   } catch (err) {
//     clearSession();
//   }
// };

// const logout = async () => {
//   await axios.post('/api/logout');
//   clearSession();
// };

// const clearSession = () => {
//   auth.isAuthenticated = false;
//   auth.username = null;
//   auth.roles = [];
//   auth.permissions = [];
// };

// const hasPermission = (perm) => {
//   return auth.permissions.includes(perm);
// };

export default {
  auth,
//   fetchSession,
//   logout,
//   hasPermission
};
